module.exports = __webpack_public_path__ + "static/005-274e647b7f4f48c0bf9d3bc9b4a3c145.jpg";